import { useTaskStore } from '../stores/taskStore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function ListItem( { name, status, index, id } ) {

    const toggleTaskStatus = useTaskStore(state => state.toggleTaskStatus)
    const removeTask = useTaskStore(state => state.removeTask)

    const badges = useTaskStore(state => state.badges)

    const splitText = name.split(': ');
    const hasSplits = splitText.length > 1;
    const badgeN = hasSplits ? badges.findIndex( item => item === splitText[0] ) : '0';
    const badge = hasSplits ? <span className={`badge badge_${badgeN}`}>{splitText[0]}</span> : '';
    const text = hasSplits ? splitText[1] : name;

    return (
        <li key={'todo_'+index} className={`todo-item ${status}`}>
            <label htmlFor={"todo_"+id}>
                <input id={"todo_"+id} checked={status === 'closed' ? 'checked' : '' } type="checkbox" onChange={ () => { toggleTaskStatus(id) }  } /> {badge}<span>{text}</span>
            </label>
            <button className="todo-item-remove" onClick={ () => { removeTask(id) }}><FontAwesomeIcon icon="trash-can" fade inverse /></button>
        </li>
    );
  }
  
  export default ListItem;
  